import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewEncapsulation} from '@angular/core';
import {InternalImpactPointService, InternalSection} from '@shared/components/internal-impact-point/internal-impact-point.service';
import {Subscription} from 'rxjs';
import {VehicleNature} from '../../../claims/claims-commons/models/vehicle.model';
import {ImpactPointTypes} from '@shared/enums/impact-point-types.enum';

@Component({
    selector: 'amd-internal-impact-point',
    templateUrl: './internal-impact-point.component.html',
    styleUrls: ['./internal-impact-point.component.scss'],
    providers: [InternalImpactPointService],
    encapsulation: ViewEncapsulation.None
})

export class InternalImpactPointComponent implements OnInit, OnChanges, OnDestroy {
    @Input() nature: VehicleNature;
    @Input() impactPoints: ImpactPointTypes[] = [];
    @Input() canEdit: boolean;
    @Output() onPointsChange: EventEmitter<ImpactPointTypes[]> = new EventEmitter();

    sections: InternalSection[] = [];
    private impactPointSub: Subscription;

    constructor(private internalImpactPointService: InternalImpactPointService) {
    }

    ngOnInit(): void {
        this.impactPointSub = this.internalImpactPointService.onImpactPointsChange
            .subscribe(impactPoints => this.onPointsChange.emit(impactPoints))
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.impactPoints && changes.impactPoints.previousValue !== changes.impactPoints.currentValue) {
            this.internalImpactPointService.impactPoints = this.impactPoints;
        }
        if (changes.nature && changes.nature.previousValue !== changes.nature.currentValue) {
            this.internalImpactPointService.nature = this.nature;
        }
        if (changes.canEdit && changes.canEdit.previousValue !== changes.canEdit.currentValue) {
            this.internalImpactPointService.canEdit = this.canEdit;
        }
        if (changes.nature && changes.nature.previousValue !== changes.nature.currentValue) {
            this.sections = this.internalImpactPointService.getSections(this.nature);
        }
    }

    ngOnDestroy(): void {
        if (this.impactPointSub) {
            this.impactPointSub.unsubscribe();
        }
    }
}
